import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const checkboxCode = "<Checkbox>Optional label</Checkbox>";

const checkboxDemo = {
    code: checkboxCode
};

export const CheckboxDemo: FunctionComponent = () => {
    return (
        <Demo demo={checkboxDemo}>
            <ComponentProps componentName="Checkbox" />
        </Demo>
    );
};
